import React from 'react';

const About = () => {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>אודות דרייבר.ישראל</h1>
        <p style={styles.subtitle}>הפלטפורמה החברתית-כלכלית של ישראל לעזרה הדדית</p>
      </header>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>החזון שלנו: קהילה חזקה יותר</h2>
        <p style={styles.text}>
          דרייבר.ישראל נולדה מתוך הבנה שהכוח הגדול ביותר שלנו טמון בקהילה. בעידן שבו הכל קורה במהירות, 
          זיהינו צורך במקום אחד שמרכז את כל הצרכים היומיומיים – מהתנדבות מהלב ועד לשירותים מקצועיים בתשלום. 
          המטרה שלנו היא לספק למשתמשים את השירות המובטח בצורה השקופה והנוחה ביותר.
        </p>
      </section>

      <div style={styles.grid}>
        <div style={styles.card}>
          <h3>מה אנחנו מציעים?</h3>
          <p>
            אנו מציעים מגוון רחב של קטגוריות סיוע הכוללות שליחויות, תיקונים בבית, עזרה לקשישים, 
            בייביסיטר וסיוע לוגיסטי. כל שירות נבחר בקפידה כדי לתת מענה אמיתי ואיכותי למשתמשים שלנו.
          </p>
        </div>

        <div style={styles.card}>
          <h3>למה לבחור בנו?</h3>
          <p>
            בניגוד לפתרונות גנריים, דרייבר.ישראל מתמקדת בבניית אמון. אנו מעודדים יצירת תוכן מקורי, 
            דירוגים אמיתיים וממשק שנועד לעזור לכם למצוא את מה שאתם מחפשים בקלות, ללא הטעיה 
            ובמינימום מאמץ.
          </p>
        </div>
      </div>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>הסיפור מאחורי דרייבר.ישראל</h2>
        <p style={styles.text}>
          הפרויקט הוקם ומנוהל על ידי <strong>Lior DiCastro</strong>, מתוך מחויבות ליצירת ערך חברתי וכלכלי 
          בישראל. במקום להשקיע בכמות גדולה של אתרים דלי תוכן, בחרנו להשקיע באתר אחד איכותי, 
          עשיר במידע ואותנטי לטובת המשתמשים שלנו.
        </p>
        <p style={styles.text}>
          הפלטפורמה שלנו עוצבה במטרה להעניק חוויית משתמש (UX) מעולה, תוך הקפדה על ניווט פשוט 
          ואספקת מידע רלוונטי בכל שלב.
        </p>
      </section>

      <footer style={styles.footer}>
        <h3>צרו קשר</h3>
        <p>יש לכם שאלות? רעיונות לשיתוף פעולה? אנחנו כאן.</p>
        <p><strong>אימייל:</strong> support@driver.org.il</p>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '40px 20px',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    lineHeight: '1.6',
    color: '#333',
    direction: 'rtl'
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    borderBottom: '2px solid #3b82f6',
    paddingBottom: '20px'
  },
  title: {
    fontSize: '2.5rem',
    color: '#1e3a8a',
    margin: '0'
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#667085'
  },
  section: {
    marginBottom: '40px'
  },
  sectionTitle: {
    fontSize: '1.8rem',
    color: '#1e3a8a',
    marginBottom: '15px'
  },
  text: {
    fontSize: '1.1rem',
    marginBottom: '15px',
    textAlign: 'justify'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
    marginBottom: '40px'
  },
  card: {
    backgroundColor: '#f8fafc',
    padding: '25px',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
  },
  footer: {
    marginTop: '60px',
    padding: '30px',
    backgroundColor: '#1e3a8a',
    color: '#fff',
    borderRadius: '12px',
    textAlign: 'center'
  }
};

export default About;